<div class="attachments-modal">

    <div class="header">
      <span>View Attachments</span>
      <span class="close-btn" (click)="close()">✕</span>
    </div>
  
    <div class="list">
  
      <div *ngIf="!attachmentData?.length" class="no-data">
        No attachments available
      </div>
  
      <div *ngFor="let file of attachmentData" class="file-row">
        <a (click)="openFile(file.AttachmentURL)">
          {{ file.FileName }}
        </a>
      </div>
  
    </div>
  
  </div>
  
